import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

const Logout = () => {
  useEffect(() => {
    // clean localStorage
    localStorage.removeItem("sesion");
    localStorage.removeItem("selectedCountry");
    // Redirect user to login page
  }, []);

  return <Navigate to="/views/signin" />;
};

export default Logout;
